import React, { useState, useEffect } from "react";
import { useContext } from "../../../context";
import { SelectType } from "./shared/SelectType";
import { Header } from "./shared/Header";
import { AppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import EditorWithPreview from "../../../../../../../../Common/EditorWithPreview";
import { NOTIFICATION_TYPE } from "../../../config";
import { useNoShowNotification } from "../../../hooks/useNoShowNotification";
import { useMarkNoShow } from "../../../hooks/useMarkNoShow";

const DEFAULT_TYPE = NOTIFICATION_TYPE.emailAndSms;
const DEFAULT_BODY = "";

function ModalNoShowNotification() {
  const {
    appointment,
    modals: {
      noShowNotification: { state, isOpen, close },
    },
  } = useContext();

  const markNoShow = useMarkNoShow();
  const notification = useNoShowNotification();

  const [notificationType, setNotificationType] = useState(DEFAULT_TYPE);

  const [notificationBody, setNotificationBody] = useState(DEFAULT_BODY);
  useEffect(() => {
    !notificationBody &&
      notification &&
      setNotificationBody(notification.bodyEmail || "");
  }, [notificationBody, notification?.bodyEmail]);

  const onMark = () => {
    if (!markNoShow.isLoading) {
      markNoShow.initiate({
        charge: state.charge,
        notificationType,
        notificationBody,
        isAdditionalProvider: state.isAdditionalProvider,
      });
    }
  };

  const onClose = () => {
    close();
    setNotificationType(DEFAULT_TYPE);
    setNotificationBody(DEFAULT_BODY);
  };

  return (
    <>
      {isOpen && (
        <div className="blackOverlay">
          <div className="vert-middle">
            <div className="loyaltyMembership start-program-main">
              <Header onClose={onClose} />
              <div className="newPopupContent">
                <div className="juvly-subtitle m-b-10">
                  {`Are you sure you want to mark as No Show ${appointment.patient.fullName}'s appointment?`}
                  <br />
                  {`This appointment will be removed from your calendar and will appear as No Show in ${appointment.patient.fullName}'s appointment history.`}
                </div>
                <SelectType
                  value={notificationType}
                  onChange={(value) => {
                    setNotificationType(value);
                    if (value === NOTIFICATION_TYPE.sms) {
                      setNotificationBody(notification.bodySms);
                    } else {
                      setNotificationBody(notification.bodyEmail);
                    }
                  }}
                />
                <p className="p-text">
                  Notification Message (optional)
                  <br />
                  <AppTranslation.Appointments path="appointmentTopNotification" />
                </p>
                <div className="newInputFileldOuter m-b-40">
                  <EditorWithPreview
                    placeholder="Email Body"
                    name="notificationBody"
                    value={notificationBody}
                    className="editor_textarea editor-preview"
                    handleEditorChange={({ notificationBody }) =>
                      setNotificationBody(notificationBody)
                    }
                  />
                </div>
              </div>
              <div>
                <button
                  onClick={onClose}
                  className="new-red-btn pull-left no-width"
                >
                  Back
                </button>
                <button
                  className="new-blue-btn pull-right"
                  onClick={onMark}
                  disabled={markNoShow.isLoading}
                >
                  {markNoShow.isLoading
                    ? "Processing..."
                    : "No Show Appointment"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

ModalNoShowNotification.useHandler = function () {
  const [state, setState] = useState(null);

  return {
    state,
    isOpen: Boolean(state),
    open: ({ charge, isAdditionalProvider }) => {
      setState({
        charge,
        isAdditionalProvider,
      });
    },
    close: () => {
      setState(null);
    },
  };
};

export { ModalNoShowNotification };
